module.exports = require("rxjs/observable/concat");